var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"avatar",class:['avatar', { 'box-shadow': _vm.boxShadow }],on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }